import { MinecraftIcon } from './MinecraftIcon';

/**
 * author: Contributors
 * id 84402452-AA4A-43D6-A26C-A0946B48310C
 * name minecraft
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minecraft.svg
 * tags
 * - Brand / Logo 
 */
export const MicrosoftMinecraftIcon = MinecraftIcon;
export default MicrosoftMinecraftIcon